import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect } from 'react';
import { t } from "i18next";
import Form from 'react-bootstrap/Form';

import { useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyDropDown(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);
    const [dropdownData, setDropdownData] = useState(question.optionList);
    
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [remark, setRemark] = useState('');
    console.log(props);

    const handleChange = (event) => {
        console.log(event.target);
        const newValue = event.target.value;
        console.log(event.target.id);
        setSelectedValue(event.target.value.id);

        const option = question.optionList.find((option) => option.id == newValue);
        setSelectedOption(option);
        
        var payload = {
            id: question.id
        };

        if(newValue && parseInt(newValue) > 0){
            payload = {
                id: question.id,
                answerList: [{
                    questionOptionId: parseInt(newValue),
                    remark: option.showRemark ? remark : '',
                }]
            };
        }

        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };

    const handleRemarkChange = (event) => {
        setRemark(event.target.value);
        
        var payload = {
            id: question.id,
            answerList: [{
                questionOptionId: selectedOption.id,
                remark: selectedOption.showRemark ? remark : '',
            }]
        };
        
        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };
    
    useEffect(() => {
    }, [selectedValue])

    return (
        <div>
            <div required={question.questionMandatory}>
                <Form.Select
                    labelId="demo-simple-select-required-label"
                    id={"question-id-" + question.id + "-option-id-0"}
                    className={"question-id-" + question.id + "-option-id-0"}
                    name={"questionList[" + question.questionSequenceNo + "].answerList[0].questionOptionId"}
                    value={selectedValue}
                    label="Select single"
                    onChange={handleChange}
                >
                    <option value="" selected="selected">Please Choose</option>
                    {dropdownData.map((option) => (
                        <option key={option} value={option.id}>
                            {option.name}
                        </option>
                    ))}
                </Form.Select>
                
                {selectedOption && selectedOption.showRemark && (
                    <Form.Control as="textarea"
                        id={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
                        className={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
                        name={"questionList[" + question.questionSequenceNo + "].answerList[" + selectedOption.optionSequenceNo + "].remark"}
                        placeholder="Remark"
                        variant="outlined"
                        value={remark}
                        onChange={handleRemarkChange}
                    />
                )}
            </div>
        </div>
    );
}
